<template>
  <div :class="$style.root">
    <i18nLink
      v-if="attributes?.slug"
      :to="{ name: 'events-slug', params: { slug: attributes?.slug } }"
      :locale="i18nCode"
      :class="$style.link"
    >
      <LayoutImageWithCaptionComponent>
        <template #image>
          <CoreImageComponent
            v-if="attributes?.coverImage?.data?.attributes"
            :image="attributes?.coverImage?.data?.attributes"
            :class="$style.coverImage"
            :showCaption="false"
            :data-orientation="getOrientation(attributes?.coverImage?.data?.attributes)"
          />
          <div
            v-else
            :class="$style.coverImagePlaceholder"
          >
            {{ title }}
          </div>
        </template>

        <template #caption>
          <span
            :class="$style.type"
          >
            {{ $t(`pages.events.label`)?.toLowerCase() }}
          </span>
          &VeryThinSpace;
          <span :class="$style.title">{{ title }}</span>

          <div
            v-if="dateTimeRange"
            :class="$style.dateRange"
          >
            <CoreDateTimeRangeComponent
              :dateStart="dateTimeRange?.dateTimeStart"
              :dateEnd="dateTimeRange?.dateTimeEnd"
            />&nbsp;<CoreTimeLabelComponent
              :dateStart="dateTimeRange?.dateTimeStart"
              :dateEnd="dateTimeRange?.dateTimeEnd"
            />
          </div>
        </template>
      </LayoutImageWithCaptionComponent>
    </i18nLink>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    data: Object
  })

  const localizedData = baseStrapiGetLocalizedData(props.data)

  const attributes = baseStrapiGetAttributes(localizedData)
  const i18nCode = baseI18nGetCodeForIso(attributes?.locale)

  // NOTE extract to base, make part of component, also add square
  const getOrientation = (image) => {
    if (image?.width && image?.height) {
      return image.width > image.height ? 'landscape' : 'portrait'
    }
  }

  const title = baseTruncateString(attributes?.title, 14)

  const dateTimeRange = computed(() => {
    if (attributes?.dateTimeRanges?.length === 1) {
      return { ...attributes?.dateTimeRanges[0] }
    } else {
      return {
        dateTimeStart: attributes?.dateTimeRanges[0]?.dateTimeStart,
        dateTimeEnd: attributes?.dateTimeRanges[attributes?.dateTimeRanges?.length - 1]?.dateTimeEnd,
      }
    }
  })

</script>

<style module>
  .root {
  }

  .link {
    composes: reset-link from global;
  }

  .heading {
  }

  .title {
    composes: font-helvetica font-size-small from global;
    text-decoration-line: underline;
  }


  .link:hover .title {
    text-decoration-line: none;
  }

  .type {
    composes: font-size-small font-helvetica label-inverted from global;
  }

  .coverImage {
    --base--image--object-fit: contain;
    --base--image--object-position: center;

    display: flex;
    justify-content: center;
  }

  .coverImage img {
  }

  .coverImage[data-orientation='portrait'] {
    --base--image--object-fit: cover;
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }

  .coverImagePlaceholder {
    composes: font-helvetica font-size-x-large from global;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 3 / 2;

    background-color: var(--color--gray);
    color: var(--color--black);
    overflow: hidden;

    padding: var(--padding--element);
  }

  .updatedAt {
    composes: font-helvetica font-size-small from global;
  }
</style>
